import { render, staticRenderFns } from "./BuyDetail.vue?vue&type=template&id=00f5e83e&scoped=true"
import script from "./BuyDetail.vue?vue&type=script&lang=js"
export * from "./BuyDetail.vue?vue&type=script&lang=js"
import style0 from "./BuyDetail.vue?vue&type=style&index=0&id=00f5e83e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f5e83e",
  null
  
)

export default component.exports